import { authServices, crudService } from '../_services/'
import { TIPO_USUARIO, history } from '../utils'

const $package = require('../../package.json')
const versaoSistema = $package?.version || '0.0.0'

export const authActions = {
  login,
  isGestor,
  isPrefeitura,
  isEmpresa,
  isMotorista,
  isFiscal,
  isUsuarioOrgaoPublico,
  isOrcamento,
  refresh,
  setUserDetails,
  logout,
  logoutUser
}

function login(username, password) {
  return (dispatch) => {
    dispatch(request({ username }))
    let apiEndpoint = 'authentication/login'
    let payload = {
      login: username,
      senha: password,
      admin: true
    }
    authServices
      .post(apiEndpoint, payload)
      .then((response) => {
        dispatch(success(response.data))
        history.push('/dashboard')
      })
      .catch((err) => {
        dispatch(failure(err))
      })
  }

  function request(user) {
    return { type: 'LOGIN_REQUEST', user }
  }

  function success(user) {
    return {
      type: 'LOGIN_SUCCESS',
      token: user.token,
      expires: user.expires,
      user: user.usuario
    }
  }

  function failure(error) {
    return { type: 'LOGIN_FAILURE', error }
  }
}

function refresh() {
  return (dispatch) => {
    const token = localStorage.getItem('token')

    const payload = {
      admin: true,
      plataforma: navigator?.userAgent,
      versaoSistema: versaoSistema
    }

    if (token !== null && token !== undefined) {
      dispatch(request(token))
      let apiEndpoint = 'authentication/refresh'
      crudService
        .postWithToken(apiEndpoint, payload, token)
        .then((response) => {
          dispatch(success(response.data))
        })
        .catch((err) => {
          dispatch(failure(err))
          dispatch(logout())
        })
    }
  }

  function request(token) {
    return { type: 'AUTHENTICATION_REFRESH_REQUEST', token }
  }

  function success(user) {
    return {
      type: 'AUTHENTICATION_REFRESH_SUCCESS',
      user: user.usuario
    }
  }

  function failure(error) {
    return { type: 'AUTHENTICATION_REFRESH_FAILURE', error }
  }
}

function isGestor() {
  const isGestor = (JSON.parse(localStorage.getItem('user'))["idTipoUsuario"] == TIPO_USUARIO.ADMIN ? true : false);
  return isGestor;
}

function isMotorista() {
  const isMotorista = (JSON.parse(localStorage.getItem('user'))["idTipoUsuario"] == TIPO_USUARIO.MOTORISTA ? true : false);
  return isMotorista;
}

function isPrefeitura() {
  const isPrefeitura = (JSON.parse(localStorage.getItem('user'))["idTipoUsuario"] == TIPO_USUARIO.GESTOR_ORGAO ? true : false);
  return isPrefeitura;
}

function isFiscal() {
  const isFiscal = (JSON.parse(localStorage.getItem('user'))["idTipoUsuario"] == TIPO_USUARIO.FISCAL ? true : false);
  return isFiscal;
}

function isUsuarioOrgaoPublico() {
  const isFiscal = (JSON.parse(localStorage.getItem('user'))["idTipoUsuario"] == TIPO_USUARIO.USUARIO_ORGAO ? true : false);
  return isFiscal;
}

function isEmpresa() {
  const isEmpresa = (JSON.parse(localStorage.getItem('user'))["idTipoUsuario"] == TIPO_USUARIO.PRESTADOR ? true : false);
  return isEmpresa;
}

function isOrcamento() {
  const isOrcamento = (JSON.parse(localStorage.getItem('user'))["idTipoUsuario"] == TIPO_USUARIO.ORCAMENTO ? true : false);
  return isOrcamento;
}

function logout() {
  return (dispatch) => {
    authServices.logout()
    dispatch(logoutUser())
    history.push('/login')
  }
}
export function setUserDetails(user) {
  return {
    type: 'LOGIN_SUCCESS',
    auth: user.auth,
    token: user.token,
    expires: user.expires,
    user: user.usuario
  }
}
export function logoutUser() {
  return {
    type: 'LOGOUT_SUCCESS'
  }
}
